export default "__VITE_ASSET__0a4c884c__"